export default __webpack_public_path__ + "static/media/GIV-icon-Text.d6eef86f.svg";